<template>
  <div class="list">
    <header>{{ list.title }}</header>
    <ul>
      <note v-for="note in list.notes" :note="note" :key="note.index"></note>
    </ul>
    <footer>
      <button v-if="!list.isWritingNote" @click="list.isWritingNote = true">
        + Write a note
      </button>
      <div class="new-note" v-else>
        <textarea class="new-note-text" v-model="list.newNote.text"></textarea>
        <label for="post-anonymously">
          <input
            type="checkbox"
            id="post-anonymously"
            name="post-anonymously"
            value="false"
            v-model="addNoteAnonymously"
          />Post anonymously</label
        >
        <button @click="addNote(list)">Add note</button>
        <button @click="cancelAddNote(list)">Cancel</button>
      </div>
    </footer>
  </div>
</template>

<script>
import Note from "./Note";

export default {
  name: "List",
  components: { Note },
  props: {
    list: Object
  },
  data() {
    return {
      addNoteAnonymously: false
    };
  },
  methods: {
    addNote(list) {
      list.isWritingNote = false;
      list.notes.push({ author: list.newNote.author, text: list.newNote.text });
      if (this.addNoteAnonymously) {
        list.newNote.author = "Anonymous";
      } else {
        list.newNote.author = "Wilson Silva";
      }
      list.newNote.text = "";
    },
    cancelAddNote(list) {
      list.isWritingNote = false;
      if (this.addNoteAnonymously) {
        list.newNote.author = "Anonymous";
      } else {
        list.newNote.author = "Wilson Silva";
      }
      list.newNote.text = "";
    }
  }
};
</script>

<style scoped>
.list {
  width: 300px;
  height: calc(100% - 10px - 17px);
}

.list > * {
  background-color: #e2e4e6;
  color: #333;
  padding: 0 5px;
}

.list header {
  padding-left: 10px;
  line-height: 36px;
  font-size: 16px;
  font-weight: bold;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.list footer {
  line-height: 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #888;
  padding: 5px;
  display: grid;
}

.list footer button:hover {
  background-color: #ccc;
}

.list footer button:focus {
  outline: none;
}

.list footer button:active {
  background-color: #bbb;
}

.list footer button {
  background-color: transparent;
  border: none;
  border-radius: 10px;
  color: #888;
  text-align: left;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  font-size: 16px;
}

.list ul {
  list-style: none;
  margin: 0;
  max-height: calc(100% - 36px - 36px);
  overflow-y: auto;
}

.new-note {
  display: grid;
}

.new-note-text {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

#post-anonymously {
  margin-right: 5px;
}
</style>
